/**
 * Instrumento selecionado + filtros do M6, atendendo o pedido do sino — C-24.
 *
 * O item de leitura atrasada abre o M6 já no instrumento (`verInstrumentoNavState`). Sem
 * pedido, a seleção começa vazia e a tela cai no primeiro visível, como sempre.
 */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ALL_DAMS } from '@/domain/instrumentos/dam-filter';
import { readInstrumentoNavState } from '@/domain/instrumentos/navegacao';
import type { InstrumentFilters } from '../domain/chart-data';

const SEM_FILTRO: InstrumentFilters = { dam: ALL_DAMS, tipo: '', sec: '' };

export function useSelecaoDoM6() {
  const { state: navState } = useLocation();
  const [selectedId, setSelectedId] = useState<string | null>(() => readInstrumentoNavState(navState));
  const [filters, setFilters] = useState<InstrumentFilters>(SEM_FILTRO);

  // Clique no sino com o M6 já aberto não remonta a tela: o pedido novo chega pelo state.
  // O filtro é limpo junto — com ele ativo, o instrumento pedido podia estar fora do
  // recorte e a seleção voltava para o primeiro visível, sem aviso (achado da revisão).
  useEffect(() => {
    const pedido = readInstrumentoNavState(navState);
    if (!pedido) return;
    setFilters(SEM_FILTRO);
    setSelectedId(pedido);
  }, [navState]);

  return { selectedId, setSelectedId, filters, setFilters };
}
